<div class="wiz-integration-content">
    <div id="full-content" class="wiz-integration-group">
        <div class="step-header">
            {{'SPECIAL_MSG.ADD_STRIKE_GUARD_ID' | translate}}
        </div>
        <toro-step-group *ngFor="let step of stepsCount | fill; let i = index;" [ngSwitch]="i" [stepNumber]="i + 1">
            <ng-container *ngSwitchCase="0" [ngTemplateOutlet]="step1"></ng-container>
        </toro-step-group>

        <toro-step-action>
            <div>
                <img src="assets/images/strike-guard-logo.png" alt="Strike Guard Logo">
            </div>
            <div class="wic-perry-weather-info">
                <div>{{'CASE_SENSITIVE.ENTER_STRIKE_GUARD_ID' | translate}}</div>
                <p-inputMask
                        [(ngModel)]="strikeGuardId"
                        class="perry-weather-integration-key"
                        mask="********-****-****-****-************"
                        characterPattern="[a-fA-F0-9]"
                        [size]="40"
                        [placeholder]="'CASE_SENSITIVE.STRIKE_GUARD_ID' | translate"
                        (paste)="onPasteApiKey($event)"
                        (cut)="onCutApiKey($event)"
                ></p-inputMask>
                <div *ngIf="showError" id="wic-perry-weather-error">{{'SPECIAL_MSG.STRIKE_GUARD_DATA_COULD_NOT_BE_RETRIEVED' | translate}}</div>
                <toro-waiting-indicator class="widget-non-draggable" *ngIf="isBusy" [isVisible]="isBusy" text="{{spinnerText | translate}}..." backgroundColor="rgba(255,255,255, .9)"></toro-waiting-indicator>
            </div>
        </toro-step-action>
    </div>
</div>

<ng-template #step1>
    <div id="step1">
        {{'SPECIAL_MSG.STRIKE_GUARD_SW_ENTER_ID' | translate}}
    </div>
</ng-template>

